import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAllPermissionsApi } from "../../Api/permissionApi";
import { mapPermissions } from "../Types/Permission/PermissionInterface";

export const getAllPermissionsThunk = createAsyncThunk(
  "getAllPermissions",
  async (user_type_id: number, { rejectWithValue }) => {
    try {
      const permissions = await getAllPermissionsApi(user_type_id);
      if (permissions.status) {
        return mapPermissions(permissions.body["data"]);
      } else {
        // If the API returns a failure status, return the error message
        return rejectWithValue(permissions.error);
      }
    } catch (error: any) {
      // Handle the case where the API call itself throws an error
      return rejectWithValue("Failed to fetch all tenderDetails");
    }
  }
);
